import { render, staticRenderFns } from "./ChatSuporteOctadesk.vue?vue&type=template&id=1fdad542"
import script from "./ChatSuporteOctadesk.vue?vue&type=script&lang=js"
export * from "./ChatSuporteOctadesk.vue?vue&type=script&lang=js"
import style0 from "./ChatSuporteOctadesk.vue?vue&type=style&index=0&id=1fdad542&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports